const locale = {
    placeholder: 'Izberite čas',
    rangePlaceholder: ['Začetni čas', 'Končni čas'],
};
export default locale;
